import { z } from 'zod';
import { defaulted, translatableString } from '../common.js';
import { blockCommonSchema, listHeaderSchema, listSelectionSchema } from './base.js';
/**
 * Ro'yxat bloklari — kontent boshqa kolleksiyalardan olinadi.
 * `mode: auto` bo'lganda API tomonida to'ldiriladi, frontend qo'shimcha
 * so'rov yubormaydi (TZ 6.1: bitta sahifa = bitta so'rov).
 */
/** 16 — Yangiliklar */
export const newsListBlock = blockCommonSchema.extend({
    type: z.literal('news-list'),
    data: listHeaderSchema.extend({
        selection: defaulted(listSelectionSchema),
        layout: z.enum(['grid', 'list']).default('grid'),
        columns: z.union([z.literal(2), z.literal(3), z.literal(4)]).default(3),
    }),
});
/** 17 — Xizmatlar */
export const servicesListBlock = blockCommonSchema.extend({
    type: z.literal('services-list'),
    data: listHeaderSchema.extend({
        selection: defaulted(listSelectionSchema),
        /** `main` — aerofototasvir, 3D-model; `repair` — ta'mirlash (TZ 3.7) */
        serviceType: z.enum(['all', 'main', 'repair']).default('all'),
        layout: z.enum(['grid', 'list']).default('grid'),
        columns: z.union([z.literal(2), z.literal(3), z.literal(4)]).default(4),
    }),
});
/** 18 — Loyihalar */
export const projectsListBlock = blockCommonSchema.extend({
    type: z.literal('projects-list'),
    data: listHeaderSchema.extend({
        selection: defaulted(listSelectionSchema),
        showFilter: z.boolean().default(false),
        columns: z.union([z.literal(2), z.literal(3)]).default(3),
    }),
});
/** 19 — Rahbariyat */
export const staffListBlock = blockCommonSchema.extend({
    type: z.literal('staff-list'),
    data: listHeaderSchema.extend({
        selection: defaulted(listSelectionSchema),
        layout: z.enum(['grid', 'list']).default('grid'),
    }),
});
/** 20 — Hujjatlar */
export const documentsListBlock = blockCommonSchema.extend({
    type: z.literal('documents-list'),
    data: listHeaderSchema.extend({
        selection: defaulted(listSelectionSchema),
        showSearch: z.boolean().default(false),
        showCategoryFilter: z.boolean().default(false),
    }),
});
/** 28 — Kurslar */
export const coursesListBlock = blockCommonSchema.extend({
    type: z.literal('courses-list'),
    data: listHeaderSchema.extend({
        selection: defaulted(listSelectionSchema),
        showSchedule: z.boolean().default(true),
    }),
});
/** 29 — Xizmat narxlari jadvali */
export const servicesPriceBlock = blockCommonSchema.extend({
    type: z.literal('services-price'),
    data: z.object({
        title: translatableString({ max: 200 }),
        selection: defaulted(listSelectionSchema),
        showPrices: z.boolean().default(true),
        note: translatableString({ max: 600 }),
    }),
});
//# sourceMappingURL=lists.js.map